/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Agents_DInputs */

const en_mk_nav_p_agents_d = /** @type {(inputs: Mk_Nav_P_Agents_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign and mention them the way you would a colleague.`)
};

const id_mk_nav_p_agents_d = /** @type {(inputs: Mk_Nav_P_Agents_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa di-assign dan di-mention seperti rekan kerja.`)
};

/**
* | output |
* | --- |
* | "Assign and mention them the way you would a colleague." |
*
* @param {Mk_Nav_P_Agents_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_agents_d = /** @type {((inputs?: Mk_Nav_P_Agents_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Agents_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_agents_d(inputs)
	return en_mk_nav_p_agents_d(inputs)
});